import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores/store';
import LoginIcon from '@mui/icons-material/Login';
import Login from '../../features/user/forms/Login';
import logo from '../../assets/blackred.png';
import { CardMedia } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GenerateNavBarMenuMobile from '../common/navBarElements/GenerateNavBarMenuMobile';
import GenerateNavBarMenuDesktop from '../common/navBarElements/GenerateNavBarMenuDesktop';
import { router } from '../router/Routes';

const topbarLink = {
    marginRight: 3,
    cursor: 'pointer',
    color: '#616161',
    whiteSpace: 'nowrap',
} as const;

interface reportingNavBar {
    text: string,
    routeId: string,
}
interface collectionNavBar {
    text: string,
    routeId: string,
}
const reportingTab: reportingNavBar[] = [
    { text: 'Start', routeId: '/kostart' },
    { text: 'Overview', routeId: '/kooverview' },
    { text: 'Report', routeId: '/koreports' },
]
const collectionTab: collectionNavBar[] = [
    { text: 'New', routeId: '/newcollection' },
    { text: 'Status', routeId: '/collectionstatus' },
]
interface profileNavBar {
    text: string,
    routeId: string,
}
const profileTab: profileNavBar[] = [
    { text: 'Password', routeId: '/password' },
    { text: 'Photo', routeId: '/photo' },
]
export default observer(function NavBarHome() {
    const { userStore, modalStore } = useStore();
    const { isLoggedIn, logout, user } = userStore;

    const [anchors, setAnchors] = React.useState<[] | HTMLElement[]>([]);

    const handleOpenAnchors = (event: React.MouseEvent<HTMLElement>) => {
        const currentAnchors = [...anchors];
        const selectedAnchor = currentAnchors.find(x => x.id === event.currentTarget.id);

        if (!selectedAnchor) {
            currentAnchors.push(event.currentTarget);
            setAnchors(currentAnchors);
        }
    };
    const handleCloseAnchors = (routeId?: string) => {
        if (routeId)
            router.navigate(routeId);
        setAnchors([]);
    };
    return (<>
        <AppBar component="nav" elevation={0} color='secondary' sx={{ backgroundColor: '#B9CDC6', p: 2, height: 240 }}>
            <Toolbar sx={{ mt: 5 }}>
                {/* Mobile view */}
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        id="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenAnchors}
                        color="default"

                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        // anchorEl={anchorElNav}
                        anchorEl={anchors.find(x => x.id === "menu-appbar")}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchors.some(x => x.id === "menu-appbar"))}
                        // open={Boolean(anchorElNav)}
                        onClose={() => handleCloseAnchors()}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                            '& .MuiPaper-root': {
                                minWidth: 100,
                                bgcolor: '#ddf0dd'
                            }
                        }}
                    >
                        {isLoggedIn && user &&
                            <>
                                <MenuItem key="Collection" aria-label="collection"
                                    aria-controls="collection-appbar"
                                    id="collection-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    // onMouseOver={handleOpenAnchors}
                                    // onMouseDown={() => handleCloseAnchors()}
                                    // onBlur={()=>handleCloseAnchors()}
                                    color="inherit">
                                    <Typography textAlign="center">Collection</Typography>
                                </MenuItem>

                                <MenuItem key="Reporting"
                                    aria-label="reporting"
                                    aria-controls="reporting-appbar"
                                    id="reporting-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    // onMouseOver={handleOpenAnchors}
                                    color="inherit">
                                    <Typography textAlign="center">Reporting</Typography>
                                </MenuItem>

                                <MenuItem key="profile"
                                    aria-label="profile"
                                    aria-controls="profile-appbar"
                                    id="profile-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    // onClick={() => handleCloseAnchors(
                                    // user && (user!.role === superAdmin || user!.role === admin) ? '/adminProfile' : '/userProfile')}
                                    color="inherit">
                                    <Typography textAlign="center">Profile</Typography>
                                </MenuItem>
                            </>
                        }
                        <MenuItem key="packinginstructions" onClick={() => handleCloseAnchors('/packingInstructions')}>
                            <Typography textAlign="center">Packing Instructions</Typography>
                        </MenuItem>
                        <MenuItem key="aboutus" onClick={() => handleCloseAnchors('/')}>
                            <Typography textAlign="center">About us</Typography>
                        </MenuItem>
                        {isLoggedIn && user &&
                            <Button
                                key="logout"
                                onClick={() => logout()}
                                // sx={{ mt: 2, color: 'white', display: 'block' }}
                                sx={topbarLink}
                            >
                                <LogoutIcon />
                            </Button>
                        }
                        {!isLoggedIn &&
                            <>
                                <Button
                                    key="login"
                                    onClick={() => modalStore.openModal(<Login />)}
                                    // sx={{ mt: 2, color: 'white', display: 'block' }}
                                    sx={topbarLink}
                                >
                                    <LoginIcon />
                                </Button>
                                <Button
                                    key="signup"
                                    onClick={() => router.navigate('/signup')}
                                    // sx={{ mt: 2, color: 'white', display: 'block' }}
                                    sx={topbarLink}
                                >
                                    <PersonAddIcon />
                                </Button>
                            </>
                        }
                    </Menu>
                    <GenerateNavBarMenuMobile anchors={anchors}
                        menuId={"reporting-appbar"}
                        handleCloseAnchors={handleCloseAnchors}
                        menuItems={reportingTab}
                    />
                    <GenerateNavBarMenuMobile anchors={anchors}
                        menuId={"collection-appbar"}
                        handleCloseAnchors={handleCloseAnchors}
                        menuItems={collectionTab}
                    />
                    <GenerateNavBarMenuMobile anchors={anchors}
                        menuId={"profile-appbar"}
                        handleCloseAnchors={handleCloseAnchors}
                        menuItems={profileTab}
                    />
                </Box>
                {/* Desktop View */}
                <Box sx={{ display: { xs: 'flex', md: 'flex' }, alignItems: 'flex-end', height: '100%' }}>
                    <CardMedia
                        component="img"
                        sx={{ width: { xs: 80, md: 160 } }}
                        image={logo}
                        alt="T1A Logo"
                        onClick={() => router.navigate('/')}
                    />
                </Box>
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginLeft: 8 }}>
                    {isLoggedIn && user &&
                        <>
                            <Button
                                key="collectionBig"
                                sx={topbarLink}
                                aria-label="collectionBig"
                                aria-controls="collection-appbarBig"
                                id="collection-appbarBig"
                                aria-haspopup="true"
                                onClick={handleOpenAnchors}
                                color="inherit"
                            >
                                Collection
                            </Button>
                            <Button
                                key="ReportingBig"
                                sx={topbarLink}
                                aria-label="reportingBig"
                                aria-controls="reporting-appbarBig"
                                id="reporting-appbarBig"
                                aria-haspopup="true"
                                onClick={handleOpenAnchors}
                                color="inherit"
                            >
                                Reporting
                            </Button>
                            <Button
                                key="ProfileBig"
                                sx={topbarLink}
                                aria-label="profileBig"
                                aria-controls="profile-appbarBig"
                                id="profile-appbarBig"
                                aria-haspopup="true"
                                onClick={handleOpenAnchors}
                                color="inherit"
                            // onClick={() => handleCloseAnchors(user && 
                            // (user!.role === superAdmin || user!.role === admin) ? '/adminProfile' : '/userProfile')}
                            >
                                Profile
                            </Button>
                        </>
                    }
              
                    <Button
                        key="Packing Instruction"
                        onClick={() => handleCloseAnchors('/packingInstructions')}
                        sx={topbarLink}
                    >
                        Packing Instruction
                    </Button>
                    <Button
                        key="About us"
                        onClick={() => handleCloseAnchors('/')}
                        sx={topbarLink}
                    >
                        About us
                    </Button>
                    {isLoggedIn && user &&
                        <Button
                            key="logout"
                            onClick={() => logout()}
                            sx={topbarLink}
                        >
                            <LogoutIcon />
                        </Button>
                    }
                    {!isLoggedIn &&
                        <>
                            <Button
                                key="login"
                                onClick={() => modalStore.openModal(<Login />)}
                                sx={topbarLink}
                            >
                                <LoginIcon />
                            </Button>
                            <Button
                                key="signup"
                                onClick={() => router.navigate('/signup')}
                                sx={topbarLink}
                            >
                                <PersonAddIcon />
                            </Button>
                        </>
                    }
                </Box>
                <GenerateNavBarMenuDesktop anchors={anchors}
                    menuId={"reporting-appbarBig"}
                    handleCloseAnchors={handleCloseAnchors}
                    menuItems={reportingTab}
                />
                <GenerateNavBarMenuDesktop anchors={anchors}
                    menuId={"collection-appbarBig"}
                    handleCloseAnchors={handleCloseAnchors}
                    menuItems={collectionTab}
                />
                <GenerateNavBarMenuDesktop anchors={anchors}
                    menuId={"profile-appbarBig"}
                    handleCloseAnchors={handleCloseAnchors}
                    menuItems={profileTab}
                />
            </Toolbar >
        </AppBar>
    </>
    );
})

